import cardTemplateSvg from "@bokio/assets/images/bokio-card-template.svg";
import { BankLangFactory } from "@bokio/lang";
import { mergeClassNames } from "@bokio/utils/classes";

import type { FC } from "react";

import * as styles from "./cardPreview.scss";

export type CardPreviewProps = {
	className?: string;
	classFont?: string;
} & (
	| {
			companyName: string | undefined;
			cardHolderName: string;
	  }
	| {
			/**
			 * Half the size and hide company name & card holder name
			 */
			mini: true;
	  }
);

export const CardPreview: FC<CardPreviewProps> = ({ className, classFont, ...props }) => {
	const bankLang = BankLangFactory();

	return (
		<div className={mergeClassNames(styles.templateBase, "mini" in props && styles.templateBaseMini, className)}>
			<img className={styles.cardImage} src={cardTemplateSvg} alt={bankLang.BokioCard} />
			{!("mini" in props) && (
				<div className={styles.overlayBase}>
					<div className={styles.namesWrapper}>
						<p className={mergeClassNames(styles.companyName, classFont)}>
							{props.companyName?.substring(0, 30) ?? ""}
						</p>
						<p className={mergeClassNames(styles.cardHolderName, classFont)}>{props.cardHolderName}</p>
					</div>
				</div>
			)}
		</div>
	);
};
